var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "dialog",
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        "close-on-press-escape": false,
        width: "40%",
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.onHandleClose,
      },
    },
    [
      _c(
        "div",
        { staticClass: "contents" },
        [
          _c(
            "el-form",
            {
              ref: "refForm",
              attrs: {
                model: _vm.formData,
                rules: _vm.formRules,
                "label-position": "right",
                "label-width": "100px",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "mb-15",
                  staticStyle: { "padding-left": "65px" },
                },
                [
                  _vm._v(" 标签： "),
                  _vm._l(_vm.showList, function (bItem, bIndex) {
                    return _c(
                      "el-tag",
                      {
                        key: bIndex,
                        staticStyle: { "margin-right": "10px" },
                        attrs: { closable: bItem.type == 2 },
                        on: {
                          close: function ($event) {
                            return _vm.close(bItem)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(bItem.name) + " ")]
                    )
                  }),
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "新增标签:", prop: "label_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "选择标签",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.formData.label_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "label_id", $$v)
                        },
                        expression: "formData.label_id",
                      },
                    },
                    _vm._l(_vm.chooseList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          disabled: item.disabled,
                          label: item.name,
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onHandleClose } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.onHandleSubmit },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }